import { render } from "./MainBannerBox.vue?vue&type=template&id=818d9a36"
import script from "./MainBannerBox.vue?vue&type=script&lang=js"
export * from "./MainBannerBox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/anderson/Developer/Landing-Page/CambiosItalo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__